// import React from 'react';
// import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, IconButton, Box, } from '@mui/material';
// import { Link } from 'react-router-dom';
// import CloseIcon from 'assets/img/CloseIcon.svg';
// import { onCloseWebsiteModal } from "store/features/modalWebisteSlice";
// import { useDispatch, useSelector } from 'react-redux';



// const WebSiteModal = () => {
//     const dispatch = useDispatch();
//     const state = useSelector((state) => {
//         return state.modalWebiste
//     })


//     const { open, type = 'success', modalConfig } = state
//     const { title, description, icon : Icon, isButton, email , buttonAction } = modalConfig || {};

//     return (
//         <Dialog
//             open={open}
//             onClose={() =>  dispatch(onCloseWebsiteModal())}
//             maxWidth="md"
//             fullWidth
//             sx={{
//                 '& .MuiDialog-paper': {
//                     borderRadius: '10px',
//                     padding: '20px',
//                     maxWidth: '700px',
//                     width: '90%',
//                 },
//             }}
//         >
//             <DialogTitle sx={{ padding: 0 }}>
//                 <Box
//                     sx={{
//                         display: 'flex',
//                         justifyContent: 'flex-end',
//                         padding: '10px',
//                     }}
//                 >
//                     <IconButton aria-label="close" onClick={() =>  dispatch(onCloseWebsiteModal())}>
//                         <img src={CloseIcon} alt="Close" width="24" height="24" />
//                     </IconButton>
//                 </Box>
//             </DialogTitle>
//             <DialogContent
//                 sx={{
//                     textAlign: 'center',
//                     padding: '0 24px 16px',
//                 }}
//             >
//                 <Box
//                     sx={{
//                         display: 'flex',
//                         justifyContent: 'center',
//                         alignItems: 'center',
//                         marginBottom: '10px',
//                     }}
//                 >
//                     <Icon />
//                     {/* <img src={icon} alt="Icon" style={{ width: '60px', height: '60px' }} /> */}
//                 </Box>
//                 <Typography
//                     variant="h6"
//                     component="h2"
//                     sx={{
//                         color: type === 'success'  ? '#52AD32' : type === 'warning' ? '#FF5F00' : '#000000',
//                         fontWeight: 'bold',
//                         marginBottom: '10px',
//                     }}
//                 >
//                     {title && title}
//                    { console.log("🚀 ~ WebSiteModal ~ title:", title)}
//                 </Typography>
//                 {description && (
//                     <Typography variant="body2" sx={{ color: '#333' }}>
//                         {description}      <Link
//                             style={{
//                                 marginLeft: "5px",
//                                 color: "#FF5F00",
//                                 fontFamily: "Roboto",
//                                 fontSize: "1.125rem",
//                                 fontWeight: 700,
//                             }}
//                         >
//                             {email}
//                         </Link>
//                     </Typography>
//                 )}
//                 <Typography variant="body2" sx={{ color: '#333', marginTop: '20px' }}>
//                     Team Venuelog
//                 </Typography>
//             </DialogContent>
//             {isButton && (
//                 <DialogActions
//                     sx={{
//                         display: 'flex',
//                         justifyContent: 'center',
//                         padding: '16px',
//                     }}
//                 >
//                     <Button
//                        onClick={() => buttonAction()}
//                         variant="contained"
//                         sx={{
//                             backgroundColor: '#F36523',
//                             color: '#FFF',
//                             '&:hover': {
//                                 backgroundColor: '#e05b20',
//                             },
//                         }}
//                     >
//                         {isButton}
//                     </Button>
//                 </DialogActions>
//             )}
//         </Dialog>
//     );
// };

// export default WebSiteModal;



import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, IconButton, Box } from '@mui/material';
import { Link } from 'react-router-dom';
import { useSpring, animated } from 'react-spring';
import { useDispatch, useSelector } from 'react-redux';
// import CloseIcon from 'lucide-react';
import CloseIcon from 'assets/img/CloseIcon.svg';

import { onCloseWebsiteModal } from "store/features/modalWebisteSlice";

const AnimatedDialog = animated(Dialog);

const WebSiteModal = () => {
    const dispatch = useDispatch();
    const state = useSelector((state) => state.modalWebiste);

    const { open, type = 'success', modalConfig } = state;
    const { title, description, icon: Icon, isButton, email, buttonAction } = modalConfig || {};

    const animation = useSpring({
        from: { opacity: 0, transform: 'scale(0.9)' },
        to: { opacity: open ? 1 : 0, transform: open ? 'scale(1)' : 'scale(0.9)' },
        config: { tension: 300, friction: 20 },
    });

    const getTypeColor = () => {
        switch (type) {
            case 'success': return '#52AD32';
            case 'warning': return '#FF5F00';
            case 'error': return '#FF0000';
            default: return '#000000';
        }
    };

    React.useEffect(() => {  
        return () => {
            dispatch(onCloseWebsiteModal())
        };
    }, [dispatch]);

    return (
        <AnimatedDialog
            open={open}
            onClose={() => dispatch(onCloseWebsiteModal())}
            maxWidth="md"
            fullWidth
            style={animation}
            sx={{
                '& .MuiDialog-paper': {
                    borderRadius: '15px',
                    padding: '30px',
                    maxWidth: '700px',
                    width: '90%',
                    boxShadow: '0 10px 25px rgba(0,0,0,0.1)',
                },
            }}
        >
            <DialogTitle sx={{ padding: 0 }}>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', padding: '10px' }}>
                    <IconButton 
                        aria-label="close" 
                        onClick={() => dispatch(onCloseWebsiteModal())}
                        sx={{ 
                            color: getTypeColor(),
                            '&:hover': { backgroundColor: 'rgba(0,0,0,0.04)' }
                        }}
                    >
                        {/* <CloseIcon size={24} /> */}
                        <img src={CloseIcon} alt="Close" width="24" height="24" />
                    </IconButton>
                </Box>
            </DialogTitle>
            <DialogContent sx={{ textAlign: 'center', padding: '0 24px 24px' }}>
                {Icon && (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '20px' }}>
                    <Icon size={80} color={getTypeColor()} />
                </Box>
                )}
                <Typography
                    variant="h5"
                    component="h2"
                    sx={{
                        color: getTypeColor(),
                        fontWeight: 'bold',
                        marginBottom: '20px',
                        fontFamily: '"Poppins", sans-serif',
                    }}
                >
                    {title}
                </Typography>
                {description && (
                    <Typography variant="body1" sx={{ color: '#555', marginBottom: '20px', fontFamily: '"Roboto", sans-serif' }}>
                        {description}
                        {email && (
                            <Link
                                style={{
                                    marginLeft: "5px",
                                    color: "#FF5F00",
                                    fontWeight: 700,
                                }}
                            >
                                {email}
                            </Link>
                        )}
                    </Typography>
                )}
                <Typography variant="body2" sx={{ color: '#777', marginTop: '30px', fontStyle: 'italic' }}>
                    - Team Venuelog
                </Typography>
            </DialogContent>
            {isButton && (
                <DialogActions sx={{ display: 'flex', justifyContent: 'center', padding: '16px' }}>
                    <Button
                        onClick={() => {
                            buttonAction()
                            dispatch(onCloseWebsiteModal())
                        }}
                        variant="contained"
                        sx={{
                            backgroundColor: getTypeColor(),
                            color: '#FFF',
                            padding: '10px 30px',
                            fontSize: '1rem',
                            fontWeight: 'bold',
                            textTransform: 'none',
                            borderRadius: '25px',
                            transition: 'all 0.3s ease',
                            '&:hover': {
                                backgroundColor: getTypeColor(),
                                opacity: 0.9,
                                transform: 'translateY(-2px)',
                                boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                            },
                        }}
                    >
                        {isButton}
                    </Button>
                </DialogActions>
            )}
        </AnimatedDialog>
    );
};

export default WebSiteModal;